class ScheduleJobMatchItemController {
    /*@ngInject*/
    constructor($rootScope, $timeout, $filter, moment, $uibModal, modalService, browserService, dateTimeUtilityService, jobMatchService, jobService, userService, userRoleService, employeeService, meetingService, alertsAndNotificationsService, sharedAjsService) {
        this.$rootScope = $rootScope;
        this.$timeout = $timeout;
        this.$filter = $filter;
        this.moment = moment;
        this.$uibModal = $uibModal;
        this.modalService = modalService;
        this.browserService = browserService;
        this.dateTimeUtilityService = dateTimeUtilityService;
        this.jobMatchService = jobMatchService;
        this.jobService = jobService;
        this.userService = userService;
        this.userRoleService = userRoleService;
        this.employeeService = employeeService;
        this.meetingService = meetingService;
        this.alertsAndNotificationsService = alertsAndNotificationsService;
        this.sharedAjsService = sharedAjsService;
    }
    $onInit() {
        //variables
        this.jobId = null;
        this.scheduleData = {
            isCompany: true,
            jobMatchId: '',
            company: '',
            feedbackType: 'SINGLE',
            note: '',
            externalNote: '',
            startDateTime: '',
            endDateTime: '',
            timeZoneName: '',
            meetingMode: 'VIDEO',
            link: '',
            users: [],
            jobLocation: this.jobLocation
        };
        this.selectedUserObject = undefined;
        this.selectedUserObjectsArray = [];
        this.externalNotesAction = {};
        this.userSearchPlaceholder = 'Type first name or last name or email to search.';
        this.itemDisplayLabel = '';
        this.usersListLabel = '';
        this.userTypeLabel = '';
        this.scheduleLabel = 'Schedule';
        this.noEditableMeetingsLabel = '';
        this.companyName = '';
        this.companyId = '';
        this.clientName = '';
        this.sharedReqUserFromCorpOrBuOrVendor = 'Corp';
        this.sharedReqCorporationName = '';
        this.sharedReqBUName = '';
        this.sharedReqVendorName = '';
        this.chosenMeeting = '';
        this.clientorbulist = [];
        this.meetingsList = [];
        this.startDate = '';
        this.startTime = '';
        this.endDate = '';
        this.endTime = '';
        this.browserTimeZone = null;
        this.addUserTabIndex = 0;
        this.buList = [];
        this.meetingModes = [];
        //flags
        this.viewMode = false;
        this.savingFlag = false;
        this.editModeFlag = false;
        this.showFormFlag = false;
        this.loadingFlag = false;
        this.isCorporateFlag = false;
        this.editableMeetingsExistFlag = false;
        this.userSearchFlag = true;
        this.showAddUserOptionFlag = true;
        this.canAddUserAtCompanyLevel = false;
        this.canAddUserAtClientOrBULevel = false;
        this.isUserVendor = false;
        this.isSharedRequisitionAccessedByVendor = false;
        this.showTagsInput = true;
        this.isFirstModifyScheduleTimeCall = false;
        this.invalidStartDateTime = false;
        this.invalidEndDateTime = false;
        this.invalidStartEndTime = false;
        this.tabsLoaded = true;
        this.isBURequired = false;
        this.companyId = this.$rootScope.userDetails.company.companyId;
        this.isCorporateFlag = (this.$rootScope.userDetails.company.companyType == 'Corporation');
        this.browserTimeZone = this.dateTimeUtilityService.guessBrowserTimeZoneName();
        this._getMeetingModes();
        if (this.isCorporateFlag || this.jobMatchObject.isSharedRequisition) {
            this._getBelongsToBu();
        }
        if (this.mode == 'edit') {
            this.editModeFlag = true;
            this.scheduleLabel = 'Modify';
            this.getScheduledItems();
        }
        else {
            this.showFormFlag = true;
        }
        if (this.isCorporateFlag) {
            if (this.jobMatchObject.isSharedRequisition && !this.editModeFlag) {
                this._getPocOnJob();
                // this.buList.push({ id: this.jobMatchObject.jobMatchClientId, name: this.jobMatchObject.jobMatchClientName })
            }
            let searchObject = {
                'searchText': '',
                'companyId': this.companyId
            };
            this.scheduleData.isCompany = this.jobMatchObject.isCorporateLevelRequisition;
            if (!this.scheduleData.isCompany) {
            }
            // this.employeeService.getPermissibleBUsForUser(searchObject, (data) {
            //     this.buList = data;
            // }, (error) {
            //     this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            // });
        }
        else if (!this.isCorporateFlag && this.jobMatchObject.isSharedRequisition && !this.editModeFlag) {
            this.isUserVendor = true;
            this.showUserDetailsFlag = true;
            this._getPocOnJob();
        }
        this.scheduleData.jobMatchId = this.jobMatchId;
        this.scheduleData.company = this.companyId;
        this.jobId = this.jobMatchObject.jobMatchJobId;
        this.companyName = this.$rootScope.userDetails.company.companyName;
        this.clientName = this.jobMatchObject.jobMatchClientName;
        this.clientId = this.jobMatchObject.jobMatchClientId;
        if (this.jobMatchObject.isSharedRequisition && !this.isCorporateFlag) {
            this.sharedReqCorporationName = this.jobMatchObject.corporateCompanyName;
            this.sharedReqBUName = this.jobMatchObject.clientOrBUName;
            this.sharedReqVendorName = this.companyName;
            if (this.jobMatchObject.isCorporateLevelRequisition) {
                this.sharedReqUserFromCorpOrBuOrVendor = 'Corp';
                this.scheduleData.isCompany = true;
            }
            else if (this.jobMatchObject.isClientOrBuLevelRequisition) {
                this.sharedReqUserFromCorpOrBuOrVendor = 'Bu';
                this.scheduleData.isCompany = false;
            }
            /*
                in vendor perspective, users can be added only for a vendor when Corp or BU is selected.
                since one of Corp or BU will be selected by default, make the addUser option disabled.
             */
            this.showAddUserOptionFlag = false;
        }
        // determine if add user option is allowed for this user
        if (this.userRoleService.isLoggedInUserSuperUserOr4dot5Admin() || (this.userRoleService.isLoggedInUserCompanyAdmin() && !this.isCorporateFlag)) {
            // admin user, add user is allowed in all cases
            this.canAddUserAtCompanyLevel = true;
            this.canAddUserAtClientOrBULevel = true;
        }
        else if (this.isCorporateFlag) {
            this.canAddUserAtCompanyLevel = !this.jobMatchObject.hasNoAccessToCreateUserUnderCorporateOnMeetingSchedule;
            this.canAddUserAtClientOrBULevel = !this.jobMatchObject.hasNoAccessToCreateUserUnderBUOnMeetingSchedule;
        }
        else {
            let clientsOrBus = [];
            this.userService.getUsersOnlyClientsOrBus(this.companyId, (data) => {
                clientsOrBus = data;
                // for non admin user
                this.userService.getUserRoleEntityScope((data) => {
                    // if scope is
                    if (data.allclientOrBU) {
                        this.canAddUserAtCompanyLevel = true;
                        this.canAddUserAtClientOrBULevel = true;
                    }
                    else if (clientsOrBus.length) {
                        this.canAddUserAtCompanyLevel = false;
                        if (_.findIndex(clientsOrBus, { companyId: this.clientId }) == -1) {
                            this.canAddUserAtClientOrBULevel = false;
                        }
                        else {
                            this.canAddUserAtClientOrBULevel = true;
                        }
                    }
                    else {
                        this.canAddUserAtCompanyLevel = false;
                        this.canAddUserAtClientOrBULevel = false;
                    }
                }, (error) => {
                    this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
                });
            }, (error) => {
                this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            });
        }
        switch (this.itemType) {
            case 'phoneScreen':
                this.itemDisplayLabel = 'Phone Screen';
                this.usersListLabel = 'Select Phone Screen';
                this.userTypeLabel = 'Phone Screener';
                this.noEditableMeetingsLabel = "No 'Scheduled' Phone Screens are available to modify !";
                break;
            case 'interview':
                this.itemDisplayLabel = 'Interview';
                this.usersListLabel = 'Select Interview';
                this.userTypeLabel = 'Interviewer';
                this.noEditableMeetingsLabel = "No 'Scheduled' Interviews are available to modify !";
                break;
        }
        if (!this.editModeFlag) {
            this.scheduleData.note = "Scheduling " + this.itemDisplayLabel;
        }
        this._initializeDateAndTimePickers();
        // to disable chrome autocomplete of the type ahead field.
        this.$timeout(() => {
            if (this.browserService.isGoogleChrome()) {
                $("[placeholder='" + this.userSearchPlaceholder + "']").attr("autocomplete", "nope");
            }
        }, 200);
    }
    _getBelongsToBu() {
        this.userService.getUserBelongsTo(this.companyId, '', '', (data) => {
            this.buList = data.buInfos;
            this.isBURequired = !data.belongsToCorp;
        }, (error) => {
            if (this.$rootScope.isOnline) {
                this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            }
        });
    }
    _getMeetingModes() {
        this.meetingModes = [
            { name: 'Phone', value: 'PHONE' },
            { name: 'Audio', value: 'AUDIO' },
            { name: 'Video', value: 'VIDEO' }
        ];
        if (this.itemType == 'interview') {
            this.meetingModes.push({ name: 'Face-to-Face', value: 'FACE_TO_FACE' });
        }
    }
    _getPocOnJob(successCallback) {
        this.jobService.getPocOnJob(this.jobMatchObject.jobMatchJobId, (data) => {
            this._massagePocData(data);
            if (successCallback) {
                successCallback();
            }
        }, (error) => {
            this.alertsAndNotificationsService.showBannerMessage(error, 'danger');
        });
    }
    _massagePocData(pocDetails) {
        if (!_.isNull(pocDetails.id)) {
            this.poc = this._getUserObject();
            this.poc.bu = pocDetails.buId;
            this.poc.buName = pocDetails.buName ? pocDetails.buName : "Corporate";
            this.poc.emailAddress = pocDetails.email;
            this.poc.firstName = pocDetails.firstName;
            this.poc.lastName = pocDetails.lastName;
            this.poc.phoneNumber = pocDetails.mobilephone;
            this.poc.title = pocDetails.title;
            this.poc.userId = pocDetails.id;
            this.poc.isPoc = true;
            this.scheduleData.users.push(this.poc);
            let tagUser = this._getAutoCompleteUserObject(this.poc);
            this.selectedUserObjectsArray.push(tagUser);
        }
    }
    onFeedbackTypeChange(feedbackType) {
        if (feedbackType == 'SINGLE') {
            angular.forEach(this.scheduleData.users, (user, key) => {
                user.isIndividual = false;
            });
        }
        else {
            angular.forEach(this.scheduleData.users, (user, key) => {
                user.isIndividual = true;
            });
        }
    }
    schedule() {
        this.$timeout(() => {
            if (this.scheduleData.users.length) {
                let uIErrorExists = false;
                // validate the forms
                angular.forEach(this.scheduleData.users, (val, key) => {
                    val.addUserForm.$submitted = true;
                    if (val.addUserForm.$invalid) {
                        uIErrorExists = true;
                    }
                });
                if (!uIErrorExists && !this.scheduleForm.$invalid) {
                    this.savingFlag = true;
                    this.scheduleData.startDateTime = this.dateTimeUtilityService.getDateTimeInAPIFormat(new Date(this.startDate + ' ' + this.startTime));
                    this.scheduleData.endDateTime = this.dateTimeUtilityService.getDateTimeInAPIFormat(new Date(this.endDate + ' ' + this.endTime));
                    if (this.editModeFlag == true) {
                        let rescheduleData = {};
                        rescheduleData.startDateTime = this.scheduleData.startDateTime;
                        rescheduleData.endDateTime = this.scheduleData.endDateTime;
                        rescheduleData.companyId = this.scheduleData.company;
                        rescheduleData.note = this.scheduleData.note;
                        rescheduleData.externalNote = this.scheduleData.externalNote;
                        rescheduleData.timeZoneName = this.scheduleData.timeZoneName;
                        rescheduleData.meetingMode = this.scheduleData.meetingMode;
                        this.sharedAjsService.rescheduleMeeting(this.chosenMeeting.id, this.scheduleData, (data) => {
                            this.savingFlag = false;
                            if (!_.isUndefined(this.saveCallback)) {
                                this.saveCallback();
                            }
                        }, (error) => {
                            this.savingFlag = false;
                            this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
                        });
                    }
                    else {
                        this.sharedAjsService.schedulePhoneScreenOrInterview(this.itemType, this.scheduleData, (data) => {
                            this.savingFlag = false;
                            if (!_.isUndefined(this.saveCallback)) {
                                this.saveCallback();
                            }
                        }, (error) => {
                            this.savingFlag = false;
                            this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
                        });
                    }
                }
            }
            else if (!this.scheduleForm.$invalid) {
                bootbox.alert({
                    closeButton: false,
                    title: "<div class='alert alert-warning' style='margin-bottom: 0px;'><i class='fas fa-exclamation-triangle fa-fw fa-lg'></i><strong>No Users Selected</strong></div>",
                    message: "Please select at least one user to schedule " + this.itemDisplayLabel + ".",
                    className: "zIndex1060",
                    buttons: {
                        ok: {
                            label: 'Ok',
                            className: 'btn-info'
                        }
                    },
                    callback: () => {
                        this.modalService.addModalOpenClassToBodyIfAnyModalIsOpen();
                    }
                });
            }
        }, 200);
    }
    getScheduledItems() {
        this.loadingFlag = true;
        let loggedInUserId = null;
        if (this.itemType == 'phoneScreen') {
            this.jobMatchService.getPhoneScreeners(this.jobMatchId, this.companyId, loggedInUserId, false, (data) => {
                this.loadingFlag = false;
                this.meetingsList = this._getMeetingsList(data);
            }, (error) => {
                this.loadingFlag = false;
                this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            });
        }
        else {
            this.jobMatchService.getInterviewers(this.jobMatchId, this.companyId, loggedInUserId, false, (data) => {
                this.loadingFlag = false;
                this.meetingsList = this._getMeetingsList(data);
            }, (error) => {
                this.loadingFlag = false;
                this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            });
        }
    }
    _getMeetingsList(response) {
        let meetingsList = [];
        let workflowStep = this.itemType == 'phoneScreen' ? 'ps' : 'in';
        angular.forEach(response, (meetingDetails, key) => {
            let meeting = {};
            let timeZone = meetingDetails.timeZone;
            if (_.isNull(timeZone)) {
                timeZone = this.browserTimeZone;
            }
            let startDateTime = new Date(meetingDetails.meetingStartTime);
            let endDateTime = new Date(meetingDetails.meetingEndTime);
            meeting.id = meetingDetails.meetingScheduleId;
            meeting.status = meetingDetails.status;
            meeting.meetingMode = meetingDetails.meetingMode;
            meeting.meetingUrl = this.meetingService.getMeetingUrl(meeting.id, workflowStep, meeting.meetingMode);
            meeting.createdByCompanyId = meetingDetails.company;
            meeting.isCreatedByClient = meeting.createdByCompanyId !== null && meeting.createdByCompanyId !== this.companyId && !this.isCorporateFlag;
            switch (meeting.status) {
                case 'SCHEDULED':
                    meeting.statusClass = 'fa fa-calendar meeting-icon-scheduled';
                    meeting.statusLabel = 'Scheduled';
                    meeting.editableFlag = true;
                    this.editableMeetingsExistFlag = true;
                    break;
                case 'OVERDUE':
                    meeting.statusClass = 'far fa-clock feedback-meeting-icon-overdue';
                    meeting.statusLabel = 'Overdue';
                    meeting.editableFlag = true;
                    this.editableMeetingsExistFlag = true;
                    break;
                case 'IN_PROGRESS':
                    meeting.statusClass = 'fa fa-hourglass-half meeting-icon-in-progress';
                    meeting.statusLabel = 'In Progress';
                    meeting.editableFlag = false;
                    break;
                case 'COMPLETED':
                    meeting.statusClass = 'fa fa-check meeting-icon-completed';
                    meeting.statusLabel = 'Completed';
                    meeting.editableFlag = false;
                    break;
                case 'CANCELLED':
                    meeting.statusClass = 'fa fa-ban meeting-icon-cancelled';
                    meeting.statusLabel = 'Canceled';
                    meeting.editableFlag = false;
                    break;
                default:
                    // set defaults
                    meeting.statusClass = 'fa fa-question meeting-icon-in-progress';
                    meeting.statusLabel = 'Status Unknown';
                    meeting.editableFlag = false;
            }
            switch (meeting.meetingMode) {
                case 'VIDEO':
                    meeting.meetingModeClass = 'fas fa-video';
                    break;
                case 'AUDIO':
                    meeting.meetingModeClass = 'fas fa-microphone';
                    break;
                case 'PHONE':
                    meeting.meetingModeClass = 'fas fa-phone';
                    break;
                case 'FACE_TO_FACE':
                    meeting.meetingModeClass = 'fas fa-user-friends';
                    break;
                default:
                    meeting.meetingModeClass = 'd-none';
                    break;
            }
            meeting.scheduledTimeInSelectedTimeZone = this.moment(startDateTime).tz(timeZone).format("MMM DD, YYYY ( hh:mm a") + ' to ' + this.moment(endDateTime).tz(timeZone).format("hh:mm a )") + ' in ' + timeZone;
            meeting.scheduledTimeInBrowserTimeZone = null;
            if (timeZone != this.browserTimeZone) {
                meeting.scheduledTimeInBrowserTimeZone = this.moment(startDateTime).format("MMM DD, YYYY ( hh:mm a") + ' to ' + this.moment(endDateTime).format("hh:mm a )") + " in your Computer's time zone (" + this.browserTimeZone + ")";
            }
            meeting.userList = [];
            meeting.userNamesLabel = '';
            angular.forEach(meetingDetails.participants, (meetingUser, k) => {
                let user = {};
                user.userId = meetingUser.id;
                user.userName = meetingUser.firstName;
                if (!_.isUndefined(meetingUser.lastName) && !_.isNull(meetingUser.lastName)) {
                    user.userName += ' ' + meetingUser.lastName;
                }
                user.isPoc = meetingUser.isPoc;
                meeting.userList.push(user);
                if (this.jobMatchObject.isSharedRequisition && !this.isCorporateFlag) {
                    if (user.isPoc) {
                        meeting.userNamesLabel = (meeting.userNamesLabel == '' ? user.userName : meeting.userNamesLabel + ', ' + user.userName);
                    }
                }
                else {
                    meeting.userNamesLabel = (meeting.userNamesLabel == '' ? user.userName : meeting.userNamesLabel + ', ' + user.userName);
                }
            });
            meetingsList.push(meeting);
        });
        return meetingsList;
    }
    meetingChanged() {
        this.showFormFlag = false;
        this.loadingFlag = true;
        this.showUserDetailsFlag = false;
        this.userSearchFlag = true;
        this.isFirstModifyScheduleTimeCall = true;
        if (this.jobMatchObject.isSharedRequisition && !this.isCorporateFlag) {
            this.isSharedRequisitionAccessedByVendor = true;
        }
        this._setUserAccessToFeedback(this.chosenMeeting.createdByCompanyId);
        this.jobMatchService.getMeetingDetails(this.chosenMeeting.id, (data) => {
            this.scheduleData.users = [];
            this.selectedUserObjectsArray = [];
            if (!this.viewMode) {
                angular.forEach(data.participants, (val, key) => {
                    val.emailAddress = val.email;
                    val.userId = val.id;
                    if (_.isNull(val.title)) {
                        val.title = '-';
                    }
                    val.selectedDepartmentObjectsArray = [];
                    if (!_.isNull(val.departmentDetail)) {
                        let department = {};
                        department.name = val.departmentDetail.name;
                        department.id = val.departmentDetail.id;
                        val.selectedDepartmentObjectsArray.push(department);
                        val.department = angular.copy(department);
                    }
                    if (!_.isNull(val.bu)) {
                        val.buId = val.bu.id;
                        val.buName = val.bu.name;
                    }
                    else {
                        val.buId = '';
                        val.buName = 'Corporate';
                    }
                    val.isIndividual = data.isIndividual;
                    this.scheduleData.users.push(val);
                });
                angular.forEach(this.scheduleData.users, (val, key) => {
                    let tagUser = this._getAutoCompleteUserObject(val);
                    this.selectedUserObjectsArray.push(tagUser);
                });
                this.addUserTabIndex = 0;
                if (this.isSharedRequisitionAccessedByVendor) {
                    this.showUserDetailsFlag = true;
                    this.userSearchFlag = false;
                    this.$timeout(() => {
                        this.addUserTabIndex = 0;
                    }, 100);
                }
            }
            else {
                this.isUserVendor = true;
                this.showUserDetailsFlag = true;
                this.userSearchFlag = false;
                this._getPocOnJob(() => {
                    this.showUserDetailsFlag = true;
                    this.$timeout(() => {
                        this.addUserTabIndex = 0;
                    }, 100);
                });
            }
            this.scheduleData.note = data.note;
            this.scheduleData.externalNote = data.externalNote;
            this.scheduleData.feedbackType = data.feedbackType;
            this.scheduleData.company = this.companyId;
            this.scheduleData.isCompany = data.isCompany;
            this.scheduleData.meetingMode = data.meetingMode;
            this.scheduleData.link = data.link;
            if (data.location !== null && data.location.city !== null) {
                data.location.city = data.location.city.name;
                this.scheduleData.jobLocation = this.jobService.getParsedJobLocationText(data.location, false);
            }
            if (!_.isNull(data.timeZoneName)) {
                // if time zone information exists
                this.scheduleData.timeZoneName = data.timeZoneName;
                // get the time stamp string in the relevant time zone.
                let currentDateTimeStringInSelectedTimeZone = new Date(this.moment().tz(this.scheduleData.timeZoneName).format("YYYY-MM-DDTHH:mm:ss.SSS"));
                let startDateTimeStringInSelectedTimeZone = this.moment(data.startTime).tz(this.scheduleData.timeZoneName).format("YYYY-MM-DDTHH:mm:ss.SSS");
                let endDateTimeStringInSelectedTimeZone = this.moment(data.endTime).tz(this.scheduleData.timeZoneName).format("YYYY-MM-DDTHH:mm:ss.SSS");
                let startDateTime = new Date(startDateTimeStringInSelectedTimeZone);
                let endDateTime = new Date(endDateTimeStringInSelectedTimeZone);
                $("#jobMatchScheduleStartDate").datepicker("setDate", startDateTime);
                $("#jobMatchScheduleStartDate").datepicker("setStartDate", currentDateTimeStringInSelectedTimeZone);
                $("#jobMatchScheduleStartDate").datepicker("update", this.$filter('fourdotfiveDateFormat')(startDateTime));
                $("#jobMatchScheduleEndDate").datepicker("setDate", endDateTime);
                $("#jobMatchScheduleEndDate").datepicker("setStartDate", startDateTime);
                $("#jobMatchScheduleEndDate").datepicker("update", this.$filter('fourdotfiveDateFormat')(endDateTime));
                $("#jobMatchScheduleStartTime").timepicker("setTime", this._getTimeStringInAMPMFormat(startDateTime));
                $('#jobMatchScheduleEndTime').timepicker("setTime", this._getTimeStringInAMPMFormat(endDateTime));
            }
            else {
                let currentDateTime = new Date();
                let startDateTime = new Date(data.startTime);
                let endDateTime = new Date(data.endTime);
                // if(startDateTime > currentDateTime) {
                $("#jobMatchScheduleStartDate").datepicker("setDate", startDateTime);
                $("#jobMatchScheduleStartDate").datepicker("setStartDate", currentDateTime);
                $("#jobMatchScheduleStartDate").datepicker("update", this.$filter('fourdotfiveDateFormat')(startDateTime));
                $("#jobMatchScheduleEndDate").datepicker("setDate", endDateTime);
                $("#jobMatchScheduleEndDate").datepicker("setStartDate", startDateTime);
                $("#jobMatchScheduleEndDate").datepicker("update", this.$filter('fourdotfiveDateFormat')(endDateTime));
                $('#jobMatchScheduleStartTime').timepicker("setTime", this._getTimeStringInAMPMFormat(startDateTime));
                $('#jobMatchScheduleEndTime').timepicker("setTime", this._getTimeStringInAMPMFormat(endDateTime));
                // } else {
                // the defaults will load.
                // }
            }
            this.$timeout(() => {
                this.isFirstModifyScheduleTimeCall = false;
            }, 2000);
            this.showFormFlag = true;
            this.loadingFlag = false;
        }, (error) => {
            this.loadingFlag = false;
            this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        });
    }
    _setUserAccessToFeedback(scheduleCreatedByCompanyId) {
        this.viewMode = scheduleCreatedByCompanyId !== null && scheduleCreatedByCompanyId !== this.companyId && !this.isCorporateFlag;
    }
    _getAutoCompleteUserObject(val) {
        let tagUser = {};
        tagUser.displayString = val.firstName;
        tagUser.displayString += _.isNull(val.lastName) ? '' : (' ' + val.lastName);
        tagUser.displayString += ' - ' + val.emailAddress;
        tagUser.id = val.userId;
        tagUser.firstName = val.firstName;
        tagUser.lastName = val.lastName;
        tagUser.email = val.emailAddress;
        tagUser.title = val.title;
        tagUser.mobilephone = val.phoneNumber;
        tagUser.isIndividual = val.isIndividual;
        tagUser.isPoc = val.isPoc;
        if (this.isCorporateFlag || this.jobMatchObject.isSharedRequisition) {
            tagUser.buId = val.buId;
            tagUser.buName = val.buName;
        }
        else {
            tagUser.departmentName = val.department;
        }
        return tagUser;
    }
    _getTimeStringInAMPMFormat(date) {
        return this.moment(date).format("hh:mm A");
    }
    _validateAndCorrectStartDateTimeAndEndDateTime() {
        let currentDateTimeStringInSelectedTimeZone = this.moment().tz(this.scheduleData.timeZoneName).format("YYYY-MM-DDTHH:mm:ss.SSS");
        let momentOfCurrentDateTime = this.moment(currentDateTimeStringInSelectedTimeZone);
        let currentStartDateTime = new Date(this.startDate + ' ' + this.startTime);
        let momentOfCurrentStartDateTime = this.moment(currentStartDateTime);
        let currentEndDateTime = new Date(this.endDate + ' ' + this.endTime);
        // if the start date is same as the current date
        let startDateAndCurrentDateAreSameFlag = momentOfCurrentStartDateTime.isSame(momentOfCurrentDateTime, 'day');
        // if the start hours are less than current hours
        let startHoursLessThanCurrentHoursFlag = momentOfCurrentStartDateTime.isBefore(momentOfCurrentDateTime, 'hour');
        // if the hours are equal but minutes are less than current minutes.
        let hoursEqualButStartMinutesLessThanCurrentMinutesFlag = (momentOfCurrentStartDateTime.isSame(momentOfCurrentDateTime, 'hour') && momentOfCurrentStartDateTime.isBefore(momentOfCurrentDateTime, 'minute'));
        this.invalidStartDateTime = momentOfCurrentDateTime.toDate() > currentStartDateTime;
        this.invalidEndDateTime = momentOfCurrentDateTime.toDate() > currentEndDateTime;
        //Do not update date time when modifying schedule is rendered
        if (!this.isFirstModifyScheduleTimeCall) {
            // this.invalidEndDateTime = false;
            this.invalidStartEndTime = false;
            if (startDateAndCurrentDateAreSameFlag && (startHoursLessThanCurrentHoursFlag || hoursEqualButStartMinutesLessThanCurrentMinutesFlag)) {
                let currentDateRoundedToTheHour = momentOfCurrentDateTime.minute() || momentOfCurrentDateTime.second() || momentOfCurrentDateTime.millisecond() ? momentOfCurrentDateTime.add(1, 'hour').startOf('hour').toDate() : momentOfCurrentDateTime.startOf('hour').toDate();
                $("#jobMatchScheduleStartTime").timepicker("setTime", this._getTimeStringInAMPMFormat(currentDateRoundedToTheHour));
                this.invalidStartDateTime = momentOfCurrentDateTime.toDate() > currentStartDateTime;
                this.invalidEndDateTime = momentOfCurrentDateTime.toDate() > currentEndDateTime;
            }
            else if (currentStartDateTime >= currentEndDateTime) {
                // after the change to 'start time', check if the existing 'end time' component keeps 'end date time' as greater than 'start date time'
                // if not, make the 'end time' 30 mins greater than current start time.
                let currentStartDateTimePlus30Minutes = momentOfCurrentStartDateTime.add('30', 'minutes').toDate();
                $("#jobMatchScheduleEndDate").datepicker("setDate", currentStartDateTimePlus30Minutes);
                $("#jobMatchScheduleEndDate").datepicker("update", this.$filter('fourdotfiveDateFormat')(currentStartDateTimePlus30Minutes));
                $('#jobMatchScheduleEndTime').timepicker("setTime", this._getTimeStringInAMPMFormat(currentStartDateTimePlus30Minutes));
                this.$timeout(() => {
                    this.invalidStartDateTime = momentOfCurrentDateTime.toDate() > currentStartDateTime;
                    this.invalidEndDateTime = momentOfCurrentDateTime.toDate() > currentStartDateTimePlus30Minutes;
                }, 200);
            }
            else {
                $("#jobMatchScheduleStartDate").datepicker("setDate", currentStartDateTime);
                $("#jobMatchScheduleStartDate").datepicker("update", this.$filter('fourdotfiveDateFormat')(currentStartDateTime));
                this.$timeout(() => {
                    this.invalidStartDateTime = momentOfCurrentDateTime.toDate() > currentStartDateTime;
                    this.invalidEndDateTime = momentOfCurrentDateTime.toDate() > currentEndDateTime;
                }, 300);
            }
            // set the start date of the end date calendar to be the current start date of the start date calendar.
            $("#jobMatchScheduleEndDate").datepicker("setStartDate", currentStartDateTime);
        }
        else {
            // Display invalid date time if the schedule is passed
            this.invalidStartEndTime = startDateAndCurrentDateAreSameFlag && (startHoursLessThanCurrentHoursFlag || hoursEqualButStartMinutesLessThanCurrentMinutesFlag);
        }
    }
    timeZoneChanged() {
        let currentDateTimeStringInSelectedTimeZone = this.moment().tz(this.scheduleData.timeZoneName).format("YYYY-MM-DDTHH:mm:ss.SSS");
        let currentDate = new Date(currentDateTimeStringInSelectedTimeZone);
        let momentOfCurrentDate = this.moment(currentDate);
        let currentDateTimeRoundedToTheHour = momentOfCurrentDate.minute() || momentOfCurrentDate.second() || momentOfCurrentDate.millisecond() ? momentOfCurrentDate.add(1, 'hour').startOf('hour').toDate() : momentOfCurrentDate.startOf('hour').toDate();
        $("#jobMatchScheduleStartDate").datepicker("setDate", currentDate);
        $("#jobMatchScheduleStartDate").datepicker("setStartDate", currentDate);
        $("#jobMatchScheduleStartDate").datepicker("update", this.$filter('fourdotfiveDateFormat')(currentDate));
        $("#jobMatchScheduleEndDate").datepicker("setDate", currentDateTimeRoundedToTheHour);
        $("#jobMatchScheduleEndDate").datepicker("setStartDate", currentDate);
        $("#jobMatchScheduleEndDate").datepicker("update", this.$filter('fourdotfiveDateFormat')(currentDateTimeRoundedToTheHour));
        $("#jobMatchScheduleStartTime").timepicker("setTime", this._getTimeStringInAMPMFormat(currentDateTimeRoundedToTheHour));
        $('#jobMatchScheduleEndTime').timepicker("setTime", this._getTimeStringInAMPMFormat(this.moment(currentDateTimeRoundedToTheHour).add(30, 'm').toDate()));
    }
    _initializeDateAndTimePickers() {
        $(document).ready(() => {
            let currentDateTimeStringInSelectedTimeZone = this.moment().tz(this.scheduleData.timeZoneName).format("YYYY-MM-DDTHH:mm:ss.SSS");
            let currentDate = new Date(currentDateTimeStringInSelectedTimeZone);
            let momentOfCurrentDate = this.moment(currentDate);
            let currentDateTimeRoundedToTheHour = momentOfCurrentDate.minute() || momentOfCurrentDate.second() || momentOfCurrentDate.millisecond() ? momentOfCurrentDate.add(1, 'hour').startOf('hour').toDate() : momentOfCurrentDate.startOf('hour').toDate();
            $('#jobMatchScheduleStartDate').datepicker({
                format: "M d, yyyy",
                startDate: currentDateTimeRoundedToTheHour,
                weekStart: 1,
                autoclose: true
            });
            // set current date as default value
            $("#jobMatchScheduleStartDate").datepicker("setDate", currentDate);
            $("#jobMatchScheduleStartDate").datepicker("update", this.$filter('fourdotfiveDateFormat')(currentDate));
            $('#jobMatchScheduleEndDate').datepicker({
                format: "M d, yyyy",
                startDate: currentDateTimeRoundedToTheHour,
                weekStart: 1,
                autoclose: true
            });
            $("#jobMatchScheduleEndDate").datepicker("setDate", currentDateTimeRoundedToTheHour);
            $("#jobMatchScheduleEndDate").datepicker("update", this.$filter('fourdotfiveDateFormat')(currentDateTimeRoundedToTheHour));
            $('#jobMatchScheduleStartTime').timepicker({
                minuteStep: 5,
                showSeconds: false,
                showMeridian: true,
                disableFocus: true,
                defaultTime: currentDateTimeRoundedToTheHour
            });
            $('#jobMatchScheduleEndTime').timepicker({
                minuteStep: 5,
                showSeconds: false,
                showMeridian: true,
                disableFocus: true,
                defaultTime: this.moment(currentDateTimeRoundedToTheHour).add(30, 'm').toDate()
            });
            $('#jobMatchScheduleStartDate').datepicker().on('changeDate', (e) => {
                this._validateAndCorrectStartDateTimeAndEndDateTime();
            });
            $('#jobMatchScheduleEndDate').datepicker().on('changeDate', (e) => {
                this._validateAndCorrectStartDateTimeAndEndDateTime();
            });
            $('#jobMatchScheduleStartTime').timepicker().on('changeTime.timepicker', (e) => {
                this._validateAndCorrectStartDateTimeAndEndDateTime();
            });
            $('#jobMatchScheduleEndTime').timepicker().on('changeTime.timepicker', (e) => {
                this._validateAndCorrectStartDateTimeAndEndDateTime();
            });
        });
    }
    toggleViewUserDetails() {
        this.showUserDetailsFlag = !this.showUserDetailsFlag;
        if (this.showUserDetailsFlag) {
            this.addUserTabIndex = 0;
        }
    }
    getUsers(searchTerm) {
        let searchObject = {
            'companyOrClientBuId': this.scheduleData.isCompany ? this.scheduleData.company : this.clientId,
            'email': searchTerm,
            'firstName': searchTerm,
            'lastName': searchTerm,
            'requisitionId': this.jobId,
            'loggedInCompanyId': this.companyId
        };
        if (this.isSharedRequisitionAccessedByVendor) {
            if (this.sharedReqUserFromCorpOrBuOrVendor == 'Corp') {
                searchObject.companyOrClientBuId = this.jobMatchObject.corporateCompanyId;
            }
            else if (this.sharedReqUserFromCorpOrBuOrVendor == 'Bu') {
                searchObject.companyOrClientBuId = this.jobMatchObject.clientOrBUId;
            }
            else if (this.sharedReqUserFromCorpOrBuOrVendor == 'Vendor') {
                searchObject.companyOrClientBuId = this.companyId;
            }
        }
        return this.userService.getFilteredUsersPromiseForTypeAhead(searchObject).then((data) => {
            angular.forEach(data, (val, key) => {
                val.displayString = val.firstName;
                val.displayString += _.isNull(val.lastName) ? '' : (' ' + val.lastName);
                val.displayString += ' - ' + val.email;
                val.buName = val.buName ? val.buName : "Corporate";
            });
            return data;
        });
    }
    _resetScheduleData() {
        _.remove(this.scheduleData.users, (user) => {
            return user.isPoc == undefined || user.isPoc == false;
        });
        _.remove(this.selectedUserObjectsArray, (userTag) => {
            return userTag.isPoc == undefined || userTag.isPoc == false;
        });
        // if(!this.userSearchFlag){
        //     // if it is add mode
        //     this.scheduleData.users.push(new this._getUserObject());
        //     this.$timeout(() => {
        //         this.addUserTabIndex = this.scheduleData.users.length;
        //     }, 200);
        // }
    }
    addUser() {
        this.scheduleData.users.push(this._getUserObject());
        this.$timeout(() => {
            this.addUserTabIndex = this.scheduleData.users.length - 1;
        }, 200);
        // if(this.scheduleData.users.length <= 1) {
        //     this.onFeedbackTypeChange('SINGLE');
        //     this.disableMultipleFeedback = true;
        // }
    }
    addEmployee() {
        $(".modal").addClass("schedule-job-match-meeting-modal-medium");
        this.$timeout(() => {
            let actionsModal = this.$uibModal.open({
                animation: true,
                ariaLabelledBy: 'modal-title',
                ariaDescribedBy: 'modal-body',
                windowTopClass: 'four-dot-five-modal-medium',
                backdrop: 'static',
                keyboard: false,
                component: 'scheduleJobMatchItemActionsModal',
                resolve: {
                    actionType: () => {
                        return 'addEmployee';
                    },
                    actionLabel: () => {
                        return 'Add Employee';
                    }
                }
            });
            actionsModal.result.then((data) => {
                let user = this._getUserObject();
                user.userId = data.entity.id;
                user.firstName = data.entity.firstName;
                user.lastName = data.entity.lastName;
                user.emailAddress = data.entity.email;
                user.title = data.entity.title;
                user.phoneNumber = data.entity.phoneNumber;
                user.department = data.entity.department;
                user.buId = data.entity.buId;
                user.isIndividual = false;
                user.buName = data.entity.bu ? data.entity.bu.name : "Corporate";
                user.selectedDepartmentObjectsArray = data.entity.department ? [{ id: data.entity.department.id, name: data.entity.department.name }] : [];
                this.scheduleData.users.push(user);
                let tagUser = this._getAutoCompleteUserObject(user);
                this.selectedUserObjectsArray.push(tagUser);
                this.$timeout(() => {
                    this.addUserTabIndex = this.scheduleData.users.length - 1;
                }, 200);
                this.$timeout(() => {
                    $(".modal").removeClass("schedule-job-match-meeting-modal-medium");
                }, 600);
            }, dismiss => {
                this.$timeout(() => {
                    $(".modal").removeClass("schedule-job-match-meeting-modal-medium");
                }, 600);
            });
        }, 300);
    }
    removeUser($index) {
        this.tabsLoaded = false;
        this.scheduleData.users.splice($index, 1);
        this.$timeout(() => {
            this.addUserTabIndex = 0;
            this.tabsLoaded = true;
        }, 1000);
    }
    _getUserObject() {
        let user = {};
        user.userId = null;
        user.temporaryUserId = Math.floor((Math.random() * 100) + 1).toString();
        user.firstName = '';
        user.lastName = '';
        user.emailAddress = '';
        user.title = '';
        user.phoneNumber = '';
        user.department = null;
        // if(this.isCorporateFlag && !this.scheduleData.isCompany) {
        //     user.buId = this.jobMatchObject.jobMatchClientId;
        // }
        user.buId = '';
        user.buName = '';
        user.department = null;
        user.isIndividual = false;
        return user;
    }
    userTypeChanged() {
        // if(this.userSearchFlag) {
        //     this._removeCreatedUsers();
        // }
        if (!this.isCorporateFlag) {
            this._resetScheduleData();
        }
        if (!this.userSearchFlag && !this.scheduleData.users.some(user => user.userId == null)) {
            this.addUser();
        }
        this.scheduleForm.$submitted = false;
    }
    _removeCreatedUsers() {
        _.remove(this.scheduleData.users, (user) => {
            return user.userId == null;
        });
    }
    companyClientUserTypeChanged(userType) {
        let usersCount = this.scheduleData.users.length;
        if (usersCount == 0 || (usersCount == 1 && this.scheduleData.users[0].isPoc) || this.isCorporateFlag) {
            this._switchCompanyClient();
        }
        else {
            this._showCompanyClientUsersRemoveWarning(userType);
        }
    }
    _showCompanyClientUsersRemoveWarning(userType) {
        let message = "The chosen user(s) will be removed. Are you sure you want to continue?";
        bootbox.confirm({
            closeButton: false,
            title: "<div class='alert alert-warning' style='margin-bottom: 0px;'><i class='fas fa-exclamation-triangle fa-fw fa-lg'></i><strong>Confirm</strong></div>",
            message: message,
            className: "zIndex1060",
            backdrop: true,
            onEscape: false,
            buttons: {
                confirm: {
                    label: 'Yes',
                    className: 'btn-info'
                },
                cancel: {
                    label: 'Cancel',
                    className: 'btn-danger'
                }
            },
            callback: (result) => {
                if (result) {
                    this._switchCompanyClient();
                }
                else {
                    this.scheduleData.isCompany = !this.scheduleData.isCompany;
                }
                this.modalService.addModalOpenClassToBodyIfAnyModalIsOpen();
            }
        });
    }
    _switchCompanyClient() {
        // reset the schedule data.
        this.showTagsInput = false;
        if (!this.isCorporateFlag) {
            this._resetScheduleData();
        }
        if (!this.isCorporateFlag && this.scheduleData.isCompany && !this.jobMatchObject.isSharedRequisition) {
            this.scheduleData.users = [];
            this.selectedUserObjectsArray = [];
        }
        // if it is staffing company and client is chosen, get poc
        if (!this.isCorporateFlag && !this.scheduleData.isCompany) {
            this.scheduleData.users = [];
            this.selectedUserObjectsArray = [];
            this._getPocOnJob();
        }
        // if it is staffing company and client is chosen, user cannot be added
        if (!this.isCorporateFlag && !this.scheduleData.isCompany) {
            this.showAddUserOptionFlag = false;
            // toggle to user search, if not already in search mode
            if (!this.userSearchFlag) {
                this.userSearchFlag = true;
                this.userTypeChanged();
            }
        }
        else {
            this.showAddUserOptionFlag = true;
        }
        if (this.scheduleData.isCompany && !this.canAddUserAtCompanyLevel) {
            // if logged in user cannot add users at company level
            this.userSearchFlag = true;
            this.userTypeChanged();
        }
        else if (!this.scheduleData.isCompany && !this.canAddUserAtClientOrBULevel) {
            // if logged in user cannot add users are client/Bu level
            this.userSearchFlag = true;
            this.userTypeChanged();
        }
        this.$timeout(() => {
            this.showTagsInput = true;
        }, 1000);
    }
    corpBuVendorUserTypeChanged(userType) {
        let usersCount = this.scheduleData.users.length;
        if (usersCount == 0 || (usersCount == 1 && this.scheduleData.users[0].isPoc)) {
            this._switchCorpBu();
        }
        else {
            this._showCorpBuUsersRemoveWarning(userType);
        }
    }
    _showCorpBuUsersRemoveWarning(userType) {
        let message = "The chosen user(s) will be removed. Are you sure you want to cancel?";
        bootbox.confirm({
            closeButton: false,
            title: "<div class='alert alert-warning' style='margin-bottom: 0px;'><i class='fas fa-exclamation-triangle fa-fw fa-lg'></i><strong>Confirm</strong></div>",
            message: message,
            className: "zIndex1060",
            backdrop: true,
            onEscape: false,
            buttons: {
                confirm: {
                    label: 'Yes',
                    className: 'btn-info'
                },
                cancel: {
                    label: 'Cancel',
                    className: 'btn-danger'
                }
            },
            callback: (result) => {
                if (result) {
                    this._switchCorpBu();
                }
                else {
                    if (userType == 'Corporation') {
                        this.sharedReqUserFromCorpOrBuOrVendor = 'Bu';
                    }
                    else {
                        this.sharedReqUserFromCorpOrBuOrVendor = 'Corp';
                    }
                }
                this.modalService.addModalOpenClassToBodyIfAnyModalIsOpen();
            }
        });
    }
    _switchCorpBu() {
        // reset the schedule data.
        this._resetScheduleData();
        if (this.sharedReqUserFromCorpOrBuOrVendor == 'Corp') {
            this.scheduleData.isCompany = true;
            this.scheduleData.company = this.jobMatchObject.corporateCompanyId;
            /*
                in vendor perspective, users can be added only for a vendor and not when Corp or BU is selected.
             */
            this.showAddUserOptionFlag = false;
            this.userSearchFlag = true;
            this.userTypeChanged();
            if (this.isUserVendor) {
                this._showPocDetails();
            }
        }
        else if (this.sharedReqUserFromCorpOrBuOrVendor == 'Bu') {
            this.scheduleData.isCompany = false;
            this.scheduleData.company = this.jobMatchObject.clientOrBUId;
            /*
                in vendor perspective, users can be added only for a vendor and not when Corp or BU is selected.
             */
            this.showAddUserOptionFlag = false;
            this.userSearchFlag = true;
            this.userTypeChanged();
            if (this.isUserVendor) {
                this._showPocDetails();
            }
        }
        else if (this.sharedReqUserFromCorpOrBuOrVendor == 'Vendor') {
            this.scheduleData.isCompany = true;
            this.scheduleData.company = this.companyId;
            /*
                in vendor perspective, users can be added only for a vendor and not when Corp or BU is selected.
             */
            this.showAddUserOptionFlag = true;
            if (!this.canAddUserAtCompanyLevel) {
                // if logged in user cannot add users are company level
                this.userSearchFlag = true;
                this.userTypeChanged();
            }
        }
    }
    _showPocDetails() {
        this.scheduleData.users.push(this.poc);
        this.showUserDetailsFlag = true;
        this.$timeout(() => {
            this.addUserTabIndex = 0;
        }, 100);
    }
    userTypeAheadUserAdded(tag) {
        this.addUser();
        this.scheduleData.users[this.scheduleData.users.length - 1].userId = tag.id;
        this.scheduleData.users[this.scheduleData.users.length - 1].firstName = tag.firstName;
        this.scheduleData.users[this.scheduleData.users.length - 1].lastName = tag.lastName;
        this.scheduleData.users[this.scheduleData.users.length - 1].emailAddress = tag.email;
        this.scheduleData.users[this.scheduleData.users.length - 1].title = tag.title;
        if (_.isNull(tag.mobilephone)) {
            this.scheduleData.users[this.scheduleData.users.length - 1].phoneNumber = '-';
        }
        else {
            this.scheduleData.users[this.scheduleData.users.length - 1].phoneNumber = tag.mobilephone;
        }
        if (!_.isNull(tag.role) && tag.role.length > 0) {
            this.scheduleData.users[this.scheduleData.users.length - 1].role = tag.role[this.scheduleData.users.length - 1].description;
        }
        if (this.isCorporateFlag || this.jobMatchObject.isSharedRequisition) {
            this.scheduleData.users[this.scheduleData.users.length - 1].buId = tag.buId;
            this.scheduleData.users[this.scheduleData.users.length - 1].buName = tag.buName;
        }
        else {
            this.scheduleData.users[this.scheduleData.users.length - 1].department = tag.departmentName;
            if (!_.isNull(tag.departmentName)) {
                let department = { 'id': tag.departmentId, 'name': tag.departmentName };
                this.scheduleData.users[this.scheduleData.users.length - 1].selectedDepartmentObjectsArray = [];
                this.scheduleData.users[this.scheduleData.users.length - 1].selectedDepartmentObjectsArray.push(department);
                this.scheduleData.users[this.scheduleData.users.length - 1].department = department;
            }
        }
        if (this.scheduleData.feedbackType == 'SINGLE') {
            this.scheduleData.users[this.scheduleData.users.length - 1].isIndividual = false;
        }
        else {
            this.scheduleData.users[this.scheduleData.users.length - 1].isIndividual = true;
        }
        // if(this.scheduleData.users.length <= 1) {
        //     this.onFeedbackTypeChange('SINGLE');
        //     this.disableMultipleFeedback = true;
        // }
    }
    userTypeAheadUserRemoved(tag) {
        if (tag.isPoc) {
            this.selectedUserObjectsArray.unshift(tag);
            bootbox.alert({
                closeButton: false,
                title: "<div class='alert alert-warning' style='margin-bottom: 0px;'><i class='fas fa-exclamation-triangle fa-fw fa-lg'></i><strong>Warning!</strong></div>",
                message: "Point of Contact cannot be removed.",
                className: "zIndex1060",
                buttons: {
                    ok: {
                        label: 'Ok',
                        className: 'btn-info'
                    }
                },
                callback: () => {
                    this.modalService.addModalOpenClassToBodyIfAnyModalIsOpen();
                }
            });
        }
        else {
            let removedIndex = _.findIndex(this.scheduleData.users, { userId: tag.id });
            this.scheduleData.users.splice(removedIndex, 1);
        }
    }
    getDepartments(searchTerm) {
        let searchObject = {
            'searchText': searchTerm,
            'companyId': this.companyId
        };
        return this.employeeService.getDepartmentsPromiseForTypeAhead(searchObject).then((data) => {
            return data;
        });
    }
    departmentTypeAheadDepartmentAdded(tag, user) {
        user.department = {};
        user.department.name = tag.name;
        if (!_.isNull(tag.id)) {
            user.department.id = tag.id;
        }
    }
    departmentTypeAheadDepartmentRemoved(tag, user) {
        user.department = null;
    }
    onInternalNoteChanged() {
        this.scheduleData.externalNote = this.scheduleData.note;
    }
    onExternalNoteChange(event) {
        this.scheduleData.externalNote = event.externalNote;
    }
    onCopyNoteChange(event) {
        this.copyNote = event.copyNote;
    }
    receiveFormalizedComment(event) {
        this.scheduleData.note = event;
        this.onInternalNoteChanged();
    }
    onVoiceTranscript(transcript) {
        if (this.scheduleData.note) {
            this.scheduleData.note += ' ' + transcript;
        }
        else {
            this.scheduleData.note = transcript;
        }
        this.onInternalNoteChanged();
    }
    resetMeeting() {
        this.meetingChanged();
    }
}
ScheduleJobMatchItemController.$inject = ['$rootScope', '$timeout', '$filter', 'moment', '$uibModal', 'modalService', 'browserService', 'dateTimeUtilityService', 'jobMatchService', 'jobService', 'userService', 'userRoleService', 'employeeService', 'meetingService', 'alertsAndNotificationsService', 'sharedAjsService'];
// import * as TEMPLATE from './schedule-job-match-item.html;
import * as TEMPLATE from 'raw-loader!./schedule-job-match-item.html';
export const ScheduleJobMatchItemComponent = {
    selector: 'scheduleJobMatchItem',
    component: {
        bindings: {
            jobMatchObject: '<',
            saveCallback: '&',
            jobLocation: '@',
            itemType: '@',
            jobMatchId: '@',
            mode: '@',
            sourceScreen: '@',
            formalizeActivityPayload: '<'
        },
        controller: ScheduleJobMatchItemController,
        // templateUrl: 'app/shared/jobMatchActions/scheduleJobMatchItem/schedule-job-match-item.html'
        template: TEMPLATE.default
    }
};
//# sourceMappingURL=schedule-job-match-item.component.js.map